import React from 'react';

import Code from '../ui/code/Code';

const CodeSnippet = props => {
  return (
    <Code code={props.code} />
  )
}

export default CodeSnippet;